import React from "react";
import googleLogo from "../img/google.png";
import microsoftLogo from "../img/microsoft.png";
import { ssoUrls } from "../lib/sso.js";

export default class SsoButtons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      btnType : 'none',
      btnTagline : '',
      btnPrefix : ''
    }
  }

  componentDidMount = () =>  {
      if(this.props.type == 'login') {
          this.setState({
            btnType : 'login',
            btnPrefix : 'Log in with ',
            btnClass : "btn btn-auth d-flex align-items-center",
            btnContainer : "sso-button-container sso-login-button-container",
            googleUrl : ssoUrls.googleLoginUrl,
            microsoftUrl : ssoUrls.microsoftLoginUrl
        });
      }
      else {
      if(this.props.type == 'link') {

        this.setState({
          btnType : 'link',
          btnPrefix : 'Link with',
          btnClass : "btn btn-auth d-flex align-items-center",
          btnContainer : "d-flex justify-content-between sso-button-container",
          googleUrl : ssoUrls.googleLinkUrl,
          microsoftUrl : ssoUrls.microsoftLinkUrl,
          showWait :false,
          currentlyLinked : this.props.linked
        });
      }
  }
}

openWindow = (url) => {

    if(this.props.type == 'link') this.props.statuslisten();
    window.open(url, "_blank");
}

getButtonClasses = (btn) => {
  if(btn == this.props.linked && this.props.type == 'link') {
    return "btn btn-auth d-flex align-items-center btn-auth-active";
  }
  else {
    return "btn btn-auth d-flex align-items-center";
  }
}

  //this.props.type = login or link

render() {

  return(
                  <div className={this.state.btnContainer}>

                      <button href="#" className={this.getButtonClasses(2)} onClick={() => this.openWindow(this.state.microsoftUrl)}>
                      <img alt={this.state.btnPrefix + " Microsoft"} className="auth-logos" src={microsoftLogo}/> <div className="text-center btn-text">{this.state.btnPrefix} Microsoft</div>
                      </button>

                      <button href="#" className={this.getButtonClasses(1)}  onClick={() => this.openWindow(this.state.googleUrl)}>
                        <img alt={this.state.btnPrefix + " Google"} className="auth-logos" src={googleLogo}/> <div className="text-center btn-text">{this.state.btnPrefix} Google</div>
                      </button>

                  </div>
  )
  }
}
